module.exports = __webpack_public_path__ + "img/icon-calendar.194df7a5.svg";